import { GoSuiteApp } from "go-app/services/types";

export const isAppInstalled = (app: GoSuiteApp, notInstalled: boolean) => {
	if (app.old || app.id.toLowerCase() === "goaccounts") return true;
	return notInstalled;
};
